import React, { useMemo } from 'react';
import { Box } from '@heycater/design-system';

import { useQualification } from 'qualification/context';
import { QUALIFICATION_STATUS } from 'qualification/context/model';
import { questions } from 'qualification/schema/questions';
import { peopleCountQuestion } from 'qualification/schema/questions/peopleCountQuestion';
import useLocalizedFieldName from 'shared/hooks/useLocalizedFieldName';
import PopularValues from 'system/components/PopularValues';
import QuantityStepperField from 'system/components/QuantityStepperField';

function QuantityStepper() {
  const { localizedAttributeName } = useLocalizedFieldName();
  const { actions, state, answerOf } = useQualification();

  const localizedOptions = useMemo(
    () =>
      questions.peopleCount.suggestions?.map((option) => ({
        value: option.value,
        // @ts-expect-error TODO: type this function
        label: option[localizedAttributeName('label')],
      })),
    []
  );

  if (state.status !== QUALIFICATION_STATUS.answering) {
    return null;
  }

  const answer = answerOf(peopleCountQuestion.id);

  return (
    <Box
      my={5}
      display="flex"
      justifyContent="center"
      flexDirection="column"
      alignItems="center"
    >
      <QuantityStepperField
        name={peopleCountQuestion.id}
        id={peopleCountQuestion.id}
        value={answer || 0}
        onChange={(value) =>
          actions.answerQuestion(peopleCountQuestion.id, value)
        }
      />
      <Box mt={4}>
        <PopularValues
          name={peopleCountQuestion.id}
          answerQuestion={(value: number) =>
            actions.answerQuestion(peopleCountQuestion.id, value)
          }
          options={localizedOptions}
        />
      </Box>
    </Box>
  );
}

export default QuantityStepper;
